import { DashSourceCode, TeamPermission } from './graphql/generated/types.generated';

export const PATHS_NO_SUBSCRIPTION_REQUIRED = ['/settings', '/subscribe'];

export const TEAM_RESTRICTED_ROUTES = [
    {
        route: /\/settings\/workspace\/billing/,
        permissions: [TeamPermission.Billing],
    },
    {
        route: /\/settings\/workspace\/general/,
        permissions: [TeamPermission.Owner],
    },
    {
        route: /\/dashboards\/create.*/,
        permissions: [TeamPermission.ManageInsights],
    },
    {
        route: /\/dashboards\/(.*)\/edit/,
        permissions: [TeamPermission.ManageInsights],
    },
    {
        route: /\/dashboards\/(.*)\/widgets\/create.*/,
        permissions: [TeamPermission.ManageInsights],
    },
    {
        route: /\/dashboards\/(.*)\/widgets\/(.*)\/edit/,
        permissions: [TeamPermission.ManageInsights],
    },
    {
        route: /\/dashboards.*/,
        permissions: [TeamPermission.ViewInsights],
    },
    {
        route: /\/settings\/workspace\/public-api/,
        permissions: [TeamPermission.ManageWorkspaceSettings],
    },
    {
        route: /\/settings\/workspace\/settings/,
        permissions: [TeamPermission.ManageWorkspaceSettings],
    },
];

export const COOKIES = {
    MAIN_NAV_OPENED: 'main-nav-opened',
    REDIRECT_AFTER_LOGIN: 'redirect-after-login',
    ONBOARDING_ID: 'onboarding-id',
};

export const FEATURE_FLAGS = {
    LEGACY_REPORTS: 'legacyReports',
    COMPOSE_BETA: 'composeBeta',
};

export const BETA_KEYS = {
    REPORTS_BETA: 'insightsBeta',
    COMPOSE_BETA: 'composeBeta',
};

export const LOCAL_STORAGE = {
    RECENT_DASHBOARDS_WORKSPACE: 'RECENT_DASHBOARDS_WORKSPACE',
    ENABLED_BETAS: 'enabledBetas',
    ONBOARDING_ICP_FILLED: 'onboarding-icp-filled',
    ONBOARDING_FINISHED: 'onboarding-finished',
};

export const HELP_RESOURCES_ARTICLES = {
    CLIENT_APPROVAL: {
        pt: '1y0fn24',
        en: '1x6fs7x',
        es: '16wxg09',
        fr: '1qmerph',
    },
    CREATE_DASHBOARD: {
        pt: '3drty2',
        en: '7ak7dk',
    },
    CREATE_BLANK_WIDGET: {
        pt: '79zlyy',
        en: '1secqzu',
    },
    DASHBOARDS_BETA_ALERT: {
        pt: '5uch3b',
        en: 'hpvxo2',
    },
    CONNECT_SOCIAL_ACCOUNTS: {
        pt: 'sgya38',
        es: '11s3b2z',
        fr: '1cue5h3',
        en: 'b868z0',
    },
    UPDATE_SOCIAL_ACCOUNTS: {
        pt: '1xtdg9l',
        en: '1q44x0s',
        es: 'd503dk',
        fr: '15ey71r',
    },
    SHARE_DASHBOARD: {
        pt: '1lg2fcy',
        en: 'g3udwc',
        es: 'hquidq',
        fr: '1nlgq2a',
    },
    INVITE_TEAM_MEMBERS: {
        pt: '85o1ov',
        en: '13yfeiu',
        es: '13hjzer',
        fr: '18hf71b',
    },
};

export const PRODUCT_LIFT_HOST = 'https://product.swonkie.com';

export const NEW_INSIGHTS_MIN_DATE = '2024-10-01';

/**
 * Workspaces created on/after this date never get the legacy post-creation flow (DEV-4478).
 * They are served fenix unconditionally and have no way to switch back. Compared in UTC so a
 * workspace created near midnight doesn't flip cohort depending on the viewer's timezone.
 */
export const FENIX_ONLY_WORKSPACE_MIN_DATE = '2026-08-01';

export const REGEX = {
    VALID_MENTION: /^([\p{L}|A-z|0-9|.]+)$/u,
};

// Random colors for new labels (same as BE)
export const LABELS_RANDOM_COLORS = [
    '#0020DD',
    '#5638F2',
    '#6F43C0',
    '#5056A9',
    '#D81B60',
    '#777680',
    '#1976D2',
    '#00658B',
    '#00885C',
    '#6D4C41',
    '#FF6F00',
    '#C5831B',
];

export const AVAILABLE_DASH_SOURCES_CODES = {
    [DashSourceCode.Instagram]: 'instagram',
    [DashSourceCode.InstagramV2]: 'instagram_v2',
    [DashSourceCode.Facebook]: 'facebook',
    [DashSourceCode.Linkedin]: 'linkedin',
    [DashSourceCode.Tiktok]: 'tiktok',
    [DashSourceCode.MetaAds]: 'facebook', //We don't have a oauth specific to meta ads
    [DashSourceCode.Threads]: 'threads',
    [DashSourceCode.FacebookPublic]: 'facebook',
    [DashSourceCode.InstagramPublic]: 'instagram',
    [DashSourceCode.GoogleMyBusiness]: 'google_my_business',
};

export const API_DOCS_URL = 'https://docs.swonkie.dev/';

export const HEADER_HEIGHT = 40;

export const LEGACY_NOT_ESSENTIAL_PATHS = [
    '/listening',
    '/home',
    '/produce-content',
    '/planning/drafts',
    '/planning/queue',
    '/planning/workflow-pool',
    '/planning/posts-workflow',
    '/planning/calendar',
    '/planning',
    '/reports/basic',
    '/reports/advanced',
    '/reports/ads-overview',
    '/reports/ads-campaigns',
    '/reports/competitors',
    '/reports',
    '/inbox',
    '/feeds/posts',
    '/feeds/my-posts',
    '/feeds/rss-feed',
    '/feeds/competitor-monitoring',
    '/feeds',
    '/settings/workspace/account-status',
    '/settings/workspace/integrations',
    '/settings/workspace/rss-content',
    '/settings/workspace/api-keys',
    '/settings/personal/notifications-legacy',
];

/**
 * Knowledge Base URL configuration for metrics and widgets documentation
 */
export const KNOWLEDGE_WIDGET_METRICS_BASE_URLS = {
    facebook: {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-facebook-nbxw97/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-facebook-1wgfp63/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/facebook-metrics-ewxkw7/',
            widgets: 'https://help.swonkie.com/en/article/facebook-widgets-9nca28/',
        },
    },
    'facebook-public': {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-concorrentes-facebook-1ppckbq/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-concorrentes-facebook-r5kt2y/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/facebook-competitors-metrics-ahxk5o/',
            widgets: 'https://help.swonkie.com/en/article/facebook-competitors-widgets-v96xrb/',
        },
    },
    instagram: {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-instagram-business-1jy9iim/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-instagram-business-wjb5j8/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/instagram-business-metrics-1d09jug/',
            widgets: 'https://help.swonkie.com/en/article/instagram-business-widgets-1rgmhgy/',
        },
    },
    'instagram-v2': {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-instagram-byjr0t/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-instagram-ix0atw/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/instagram-metrics-1dwrvuc/',
            widgets: 'https://help.swonkie.com/en/article/instagram-widgets-fv3aop/',
        },
    },
    'instagram-public': {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-concorrentes-instagram-1gtka2c/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-concorrentes-instagram-1e27f7i/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/instagram-competitors-metrics-1jy0fh9/',
            widgets: 'https://help.swonkie.com/en/article/instagram-competitors-widgets-w9pg1w/',
        },
    },
    linkedin: {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-linkedin-1vp23hz/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-linkedin-xbi6fk/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/linkedin-metrics-mcjwxg/',
            widgets: 'https://help.swonkie.com/en/article/linkedin-widgets-bcyg84/',
        },
    },
    'meta-ads': {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-meta-ads-13stgmr/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-meta-ads-g6t6nu/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/meta-ads-metrics-tecst/',
            widgets: 'https://help.swonkie.com/en/article/meta-ads-widgets-2li2ys/',
        },
    },
    threads: {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-threads-dbulz2/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-threads-bk7cxc/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/threads-metrics-mlqdkc/',
            widgets: 'https://help.swonkie.com/en/article/threads-widgets-4fevee/',
        },
    },
    tiktok: {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-tiktok-fxer0s/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-tiktok-1vmb1f8/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/tiktok-metrics-le4pjo/',
            widgets: 'https://help.swonkie.com/en/article/tiktok-widgets-14zuj6w/',
        },
    },
    youtube: {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-youtube-1q7u06t/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-youtube-nx1iqj/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/youtube-metrics-1uzvu8s/',
            widgets: 'https://help.swonkie.com/en/article/youtube-widgets-1kuo1lm/',
        },
    },
    generic: {
        pt: {
            metrics: 'https://help.swonkie.com/pt/article/metricas-genericas-gpeqxe/',
            widgets: 'https://help.swonkie.com/pt/article/widgets-genericos-qtv72n/',
        },
        en: {
            metrics: 'https://help.swonkie.com/en/article/generic-metrics-1cd54n6/',
            widgets: 'https://help.swonkie.com/en/article/generic-widgets-1ssys5n/',
        },
    },
};

export const SWONKIE_DEV_PATHS = [
    '/main',
    '/settings/personal/general',
    '/settings/personal/security',
    '/settings/personal/privacy',
    '/settings/workspace/general',
    '/settings/workspace/account-status',
    '/settings/workspace/social-profile',
    '/settings/workspace/billing',
    '/settings/workspace/public-api',
    '/settings/subscription-expired',
];

export const PLANS_YEARLY_DISCOUNT = 0.85;
export const HIDE_ONBOARDING_FOR_PATHS = ['/settings/personal/privacy'];
